export default "__VITE_ASSET__e82d4859__"